import script from "./page-content.vue?vue&type=script&setup=true&lang=js"
export * from "./page-content.vue?vue&type=script&setup=true&lang=js"

import "./page-content.vue?vue&type=style&index=0&id=a0d3747e&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0d3747e"]])

export default __exports__